import * as React from 'react';
import { Box, Text, VStack } from '@chakra-ui/react';
import { IScoreboardTheme } from '../types';
import { ColorField } from './ColorField';

interface ColorsSectionProps {
  theme: IScoreboardTheme;
  onUpdate: (updates: Partial<IScoreboardTheme>) => void;
}

export const ColorsSection = ({
  theme,
  onUpdate,
}: ColorsSectionProps): React.ReactElement => (
  <Box role='group' aria-labelledby='colors-section-label'>
    <Text
      id='colors-section-label'
      fontSize='xs'
      fontWeight={700}
      textTransform='uppercase'
      letterSpacing='wider'
      color='var(--scoreboard-text-secondary, #b0b0b0)'
      mb={3}
    >
      Colors
    </Text>
    <VStack gap={3} align='stretch'>
      <ColorField
        label='Primary Color'
        value={theme.primaryColor}
        onChange={(v: string): void => onUpdate({ primaryColor: v })}
      />
      <ColorField
        label='Secondary Color'
        value={theme.secondaryColor}
        onChange={(v: string): void => onUpdate({ secondaryColor: v })}
      />
      <ColorField
        label='Background Start'
        value={theme.backgroundColor}
        onChange={(v: string): void => onUpdate({ backgroundColor: v })}
      />
      <ColorField
        label='Background End'
        value={theme.backgroundColorSecondary || '#1a1a2e'}
        onChange={(v: string): void =>
          onUpdate({ backgroundColorSecondary: v })
        }
      />
      <ColorField
        label='Banner Background'
        value={theme.bannerBackground}
        onChange={(v: string): void => onUpdate({ bannerBackground: v })}
      />
      <ColorField
        label='Card Background'
        value={theme.cardBackground}
        onChange={(v: string): void => onUpdate({ cardBackground: v })}
      />
      <ColorField
        label='Text Primary'
        value={theme.textPrimary}
        onChange={(v: string): void => onUpdate({ textPrimary: v })}
      />
      <ColorField
        label='Text Secondary'
        value={theme.textSecondary}
        onChange={(v: string): void => onUpdate({ textSecondary: v })}
      />
    </VStack>
  </Box>
);
